module.exports = __webpack_public_path__ + "img/vote_index_banner.1ca1915b.png";